import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import {T, useT} from 'react-polyglot-hooks';
import {RouteComponentProps} from 'react-router';
import useReactRouter from 'use-react-router';
import verifyEmail from './verifyEmail.api';

export const VerifyEmail = () => {
    const {history, match}: RouteComponentProps<{ id: string, email: string }> = useReactRouter();
    const {id, email} = match.params;
    const [sendVerifyEmail] = verifyEmail();
    const [dataSent, setDataSent] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    const t = useT();

    if (!id || !email) {
        history.push(`/login`);
    }

    if (!dataSent) {
        sendVerifyEmail({variables: {id, email: decodeURIComponent(email!)}})
            .then((response) => {
                const message = response.data!.verifyEmail!.message;
                enqueueSnackbar(response.data!.verifyEmail!.message, {variant: 'success'});
                history.push(`/login?message=${encodeURI(message)}`);
            })
            .catch(() => {
                enqueueSnackbar(t('There was an error communicating with the server.'), {variant: 'error'});
            });

        setDataSent(true);
    }

    return (<div><T phrase="Verifying email..."/></div>);
};

export default VerifyEmail;